var _ellipse, _path, _path2, _circle, _path3, _path4, _circle2, _circle3, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _circle4, _path6, _rect6, _rect7, _path7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 360,
    viewBox: "0 0 420 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210,
    cy: 318,
    rx: 118,
    ry: 18,
    fill: "#2A1010",
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 168c-18 42-16 86 4 118h76c18-32 22-78 6-118-10-8-66-10-86 0z",
    fill: "#1E2A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176 172c8 46 10 86 8 112h54c6-28 8-70-2-112-8-6-48-8-60 0z",
    fill: "#2B3B68"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 118,
    r: 46,
    fill: "#F2C7A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168 118c4-34 28-52 58-48 22 4 38 22 40 46-18-10-46-12-70-4-10 4-20 6-28 6z",
    fill: "#4A7CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186 108c6 8 16 12 28 10",
    stroke: "#C98B6A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 120,
    r: 4,
    fill: "#2B1B14"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 120,
    r: 4,
    fill: "#2B1B14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200 136c8 8 20 8 28 0",
    stroke: "#C45B4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 86,
    width: 132,
    height: 168,
    rx: 16,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 108,
    width: 100,
    height: 22,
    rx: 6,
    fill: "#F0EEF4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 140,
    width: 100,
    height: 22,
    rx: 6,
    fill: "#F0EEF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 262,
    y: 196,
    width: 100,
    height: 28,
    rx: 8,
    fill: "#E03C3D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 78,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#E03C3D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 74,
    r: 22,
    fill: "#E03C3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308 74l7 7 14-14",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 196,
    width: 72,
    height: 88,
    rx: 10,
    fill: "#FFFFFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 210,
    width: 48,
    height: 48,
    rx: 6,
    stroke: "#E03C3D",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 234h28M128 220v28",
    stroke: "#E03C3D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 266,
    width: 40,
    height: 8,
    rx: 4,
    fill: "#E03C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginHero);
export default __webpack_public_path__ + "static/media/login-hero.3e4dc079446440554f610d120690cd20.svg";
export { ForwardRef as ReactComponent };